
import * as React from "react";
import Header from "../../Header";
import Footer from "../../Footer";
import { IActiveOrders } from "../../../interfaces/IOrder";
import { Api } from "../../../lib/Api";
import OrderRow from "./OrderRow";
import $ from "jquery";
import DateTool from "../../../../avernus/datetool/source/DateTool";
import { ISetUrl } from "../../../AppMain";
import PendingOrderRow from "./PendingOrderRow";
import ShowOrder from "./ShowOrder";
import LoaderComp from "../../../../avernus/loader/source/LoaderComp";

interface IOrderListProps {
    setUrl                  : ISetUrl
    restaurantId            : number
    title                   : string
    showJustActiveOrders    ?: boolean
}

interface IOrderTypeWithNumber{
    id   : number
    name : string
    max  : number
}

interface IOrderListState {
    items                        : Array<Array<IActiveOrders>>
    version                      : number
    showJustActiveOrders         : boolean
    loading                      : boolean
    success                      : string
    error                        : string
    fromDate                     : string
    toDate                       : string
    commentModalContent          : string
    openCommentModal             : boolean
    orderId                      : number
}

interface IGetListResult {
    items                  : any
    orderTypeOptions       : Array<IOrderTypeWithNumber>
    currentRestaurantIsOpen: boolean
}

export default class OrderList extends React.Component<IOrderListProps, IOrderListState>{

    private restaurantId:number;

  	constructor(props:IOrderListProps){
        super(props);
        let showJustActiveOrders = this.props.showJustActiveOrders !== undefined && this.props.showJustActiveOrders === true;
        this.state = {
            version                         : 0,
            success                         : null,
            error                           : null,
            items                           : null,
            showJustActiveOrders            : showJustActiveOrders,
            loading                         : true,
            fromDate                        : showJustActiveOrders?DateTool.getDate():DateTool.getDate(DateTool.modifyDateWithDay(-1)),
            toDate                          : DateTool.getDate(),
            commentModalContent             : null,
            openCommentModal                : false,
            orderId                         : 0
        };
        this.restaurantId = null;
        if ( this.props.restaurantId !== undefined ) {
            this.restaurantId = this.props.restaurantId;
        }
        this.init();
    }

    private init(){
        document.body.classList.remove('modal-open');
        if ( this.state.loading === false ) {
            this.setState({
                loading: true
            }, () =>{
                this.getData();
            });
        }else{
            this.getData();
        }
    }

    private getData():void{
        if ( this.state.loading === false) {
            this.setState({
                loading                : true,
                openCommentModal       : false,
                commentModalContent    : ''
            });
        }
        Api.call('/restaurants/order/getOrders', {
            restaurantId            : this.restaurantId,
            fromDate                : this.state.fromDate,
            toDate                  : this.state.toDate,
            showJustActiveOrders    : this.state.showJustActiveOrders,
            dailySeparation         : true
        }, (result:IGetListResult)=>{
            console.log(result);
            this.setState({
                items                     : result.items,
                version                   : (this.state.version + 1),
                loading                   : false
            });
        });
    }


    private changeOrderId(id) {
          this.setState({
              orderId: id
          });
    }



    private closeOrder(){
          this.setState({
              orderId: 0
          });
          this.getData();
    }




    render() {
        let title = this.props.title;
        return (
            <div id="restaurant_orderlist" className={this.state.showJustActiveOrders===true?'show_just_active':''}>
               <Header
                    title = {''}
                    setUrl={ this.props.setUrl }
                ></Header>
                <div className="container content_section">
                    <div className={"h1_box"}>
                        <h1>Orders</h1>
                    </div>
                    {
                        this.state.orderId == 0 ?
                            this.OrderListSection() :
                            <ShowOrder item={this.state.items.find(item => item.id == this.state.orderId)} reload = {() => this.closeOrder()} setUrl = {this.props.setUrl}/>
                    }

                </div>
               <Footer setUrl={this.props.setUrl}></Footer>
			</div>
        );
    }



    private OrderListSection() {
        const pendingStatuses = ['pending', 'modify_hour', 'waiting_photo_request'];
        return <section className="order_list">
            {this.state.items === null || this.state.loading === true ? <div className="text-center">
                <LoaderComp show={true} />
            </div> : <div>
                    { this.state.items.length === 0 &&
                        <div className="text-center">
                        Empty result!
                        </div>
                    }

                {
                    this.state.items.filter(item => item.status.key == 'completed').length != 0 &&
                    <>
                        <p className = "title">Waiting for review</p>
                        {
                            this.state.items.filter(item => item.status.key == 'completed').map((item, rowIndex) => {
                                return <OrderRow
                                    key={rowIndex+'_'+rowIndex}
                                    item={item}
                                    changeOrderId = {(id) => this.changeOrderId(id)}
                                />;
                            })
                        }
                    </>
                }



                    {
                        this.state.items.filter(item => pendingStatuses.includes(item.status.key)).length != 0 &&
                        <>
                            <p className = "title">Pending orders</p>
                            {
                                this.state.items.filter(item => pendingStatuses.includes(item.status.key)).map((item, rowIndex) => {
                                    return <PendingOrderRow
                                        key={rowIndex+'_'+rowIndex}
                                        item={item}
                                        changeOrderId = {(id) => this.changeOrderId(id)}
                                    />;
                                })
                            }
                        </>
                    }

                    {
                        this.state.items.filter(item => item.status.key == 'processing').length != 0 &&
                        <>
                            <p className = "title">Active orders</p>
                            {
                                this.state.items.filter(item => item.status.key == 'processing').map((item, rowIndex) => {
                                    return <OrderRow
                                        key={rowIndex+'_'+rowIndex}
                                        item={item}
                                        changeOrderId = {(id) => this.changeOrderId(id)}
                                    />;
                                })
                            }
                        </>
                    }

                </div>}

        </section>;
    }
}
